/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInConnectionRequestStepPriority } from './linkedInConnectionRequestStepPriority';
import type { LinkedInConnectionRequestStepTaskNoteDoc } from './linkedInConnectionRequestStepTaskNoteDoc';
import type { StepScheduleDelay } from './stepScheduleDelay';
import type { StepScheduleImmediate } from './stepScheduleImmediate';
import type { StepScheduleSoonestAt } from './stepScheduleSoonestAt';

export interface LinkedInConnectionRequestStep {
  schedule: StepScheduleImmediate | StepScheduleSoonestAt | StepScheduleDelay;
  priority?: LinkedInConnectionRequestStepPriority;
  type: 'linkedin_connection_request';
  invitation_note?: string | null;
  include_sender_signature?: boolean;
  task_note_doc?: LinkedInConnectionRequestStepTaskNoteDoc;
}
